<div class="loading-bar">
  <mat-progress-bar *ngIf="!hidden" mode="indeterminate"></mat-progress-bar>
</div>
